import * as React from 'react';

import {EmptyStateMarketing} from '../../empty-states/empty-state-marketing';
import {ErrorState} from '../../error-state/error-state';
import {LoadingPage} from '../../loading-page/loading-page';
import {Table} from '../../table/table';
import type {Column} from '../../table/types';

type Props = {
    // @ts-expect-error
    columns: Column<any>[];
    items: any[];
    error: string | null | undefined;
    isLoading: boolean;
    emptyStateProps: {
        title: string;
        subtitle?: string;
        cta?: React.ReactNode;
    };
};

export function TableWrapper(props: Props) {
    return (
        <div className='full-width full-height'>
            <Table
                isStriped={true}
                isResizable={false}
                hasHeaderBorder={true}
                hasHeaderCellBorders={false}
                hasHeaderRightBorder={false}
                isCompact={true}
                hasBorders={true}
                fullWidth={true}
                disableSorting={true}
                disableFilters={true}
                shouldShowFooter={false}
                columns={props.columns}
                data={props.items}
                specialStates={[
                    {
                        shouldRender: () => Boolean(props.error),
                        component: <ErrorState errorMessage={props.error} size='small' />,
                    },
                    {
                        shouldRender: () => props.isLoading,
                        component: <LoadingPage padding={32} />,
                    },
                    {
                        shouldRender: () => !props.error && !props.isLoading && !props.items.length,
                        component: <EmptyStateMarketing {...props.emptyStateProps} />,
                    },
                ]}
            />
        </div>
    );
}
